export default "__VITE_ASSET__ieFJJmvA__"